<template>

  <div :id="'ep'+epIndexTabContentEdit" class="tab-pane" :class="{ 'active': isActive('ep' + epIndexTabContentEdit) }"> 
    <!-- begin::Ep name -->
    <div class="form-group">
        <label class="control-label col-sm-2">Episode name (*): </label>
        <div class="col-sm-10">
            <input type="text" class="form-control" :name="'episode_name_edit_new[' + epIndexTabContentEdit + ']'">
        </div>
    </div>
    <!-- end::Ep name -->

    <!-- begin::EpSubAddEdit -->
      <div class="form-group">
          <label class="control-label col-sm-2">Subtitle (*): </label>
          <div class="col-sm-10">

            <!-- Begin::Add Sub -->
            <div class="row" :data-sub="epIndexSubEdit">
                
                <div class="col-sm-2"> 
                <select :name="'epSubLabelNew[' + epIndexTabContentEdit + '][]'" class="form-control">
                  <option v-for="label in tv_captions" :value="label.id">{{ label.label_name }}</option>
                </select>
                </div>

                <div class="col-sm-9"> 
                  <input type="file" :name="'epSubFileEditNew[' + epIndexTabContentEdit + '][]'" :id="'epUploadSubEdit' + epIndexTabContentEdit + '1'" data-show-preview="false">
                </div>

                <div class="col-sm-1">
                  <button type="button" @click.prevent="epAddSubEdit" class="btn btn-success"><i class="icon-add"></i></button>
              </div>  
              
            </div>
            <!-- End::Add Sub -->
          
            <file-ep-sub-add-edit v-for="(epSubEdit, index) in epSubsEdit"
                 :key="epSubEdit.id" :epIndexSubEdit="index + 2" :epIndexTabContentEdit="epIndexTabContentEdit" :tv_captions="tv_captions" @epRemoveSubEdit="epRemoveSubEdit(index)">
            </file-ep-sub-add-edit>

          </div>
      </div>
    <!-- end::EpSubAddEdit -->

    <!-- begin:server -->
    <div class="form-group">
        <label class="control-label col-sm-2">Server (*): </label>
        <div class="col-sm-10">
      <div v-for="server in tv_servers" class="form-group">
        <div  id="sv-block" class="pb-30">
            <div class="col-sm-3"> 
              <input type="text" :value="server.server_name" class="form-control" readonly="readonly">
              <input type="hidden" :name="'cate_id_edit_new[' + epIndexTabContentEdit + '][]'" :value="server.id" class="form-control">
            </div>

            <div class="col-sm-9"> 
              <input type="text" :name="'link_edit_new[' + epIndexTabContentEdit + '][]'" class="form-control">
            </div>
        </div>
       </div>
        </div>
    </div>
    <!-- end::server -->
  </div>

</template>

<script>
import axios from 'axios'
import lodash from 'lodash'
const token = localStorage.getItem('token')
import EpSubAddEdit from '../child/EpSubAddEdit'

export default {
  props: ['epIndexTabContentEdit', 'tv_captions', 'tv_servers'],
  components: {'file-ep-sub-add-edit': EpSubAddEdit},
  name: 'EpTabContentAddEdit',
  data () {
    return {
      epSubsEdit: [],
      epIndexSubEdit: 1,
      counterSubEdit: 1
    }
  },
  computed: {
   
  },
  mounted() {
    let vm = this;

    Ladda.bind('button[type=submit]')

    $("#epUploadSubEdit" + vm.epIndexTabContentEdit + vm.epIndexSubEdit).fileinput({
        theme: "explorer",
        browseClass: "btn btn-primary",
        removeClass: "btn btn-danger",
        showUpload: false,
        overwriteInitial: false,
        initialPreviewAsData: false,
        allowedPreviewTypes: null,
        allowedFileExtensions: ["srt", "vtt"]
    });

  },
  methods:{
    isActive (menuItem) {

      //return this.activeItem === menuItem
      this.$emit('isActive', {menuItem})
    },
    epAddSubEdit(){
      this.counterSubEdit += 1;
      this.epSubsEdit.push({ epSubEdit: '', id: this.counterSubEdit });
      this.epIndexSubEdit += 1
    },
    epRemoveSubEdit(index){
        this.epSubsEdit.splice(index, 1)
        this.epIndexSubEdit -= 1
    },
    //
   }
  //
}
</script>

<style lang="css" scoped>
</style>


// WEBPACK FOOTER //
// src/components/child/EpTabContentAddEdit.vue